module.exports = __webpack_public_path__ + "img/document-text.b97fddc3.svg";